import React from 'react';
import { FaStar } from 'react-icons/fa';

// Sample review data
const reviews = [
  {
    name: 'Abanti Mukherjee',
    university: 'Techno India University, (BCA)',
    feedback: 'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
  },
  {
    name: 'Sakshi Shrivastav',
    university: 'Government Engineering College Patan, (CSE)',
    feedback: 'All over this all session very useful us not only as web development but also how to work in industry. Thank you all whose provides us this great opportunity. Thank you our mentor and InternsElite for giving us this great opportunity and training.',
  },
  {
    name: 'Gandham Siva Sai Surya Vardhan',
    university: 'Andhra University',
    feedback: 'Overall Feedback about the internship is amazing. I liked the way of teaching concepts and clarifying doubts, and they also provided recorded classes. Helped in the completion of the project.',
  },
  {
    name: 'Samarth. M. Kasu',
    university: 'Sinhgad Institute of Technology, Lonavla, IT',
    feedback: 'This internship program was a valuable learning experience. The structure of the program was commendable, with involvement in various projects. The mentorship provided was exceptional and helped me a lot in my development.',
  },
  {
    name: 'Rohit Rajendra Gaikwad',
    university: 'Sinhgad Academy of Engineering Kondhwa, IT',
    feedback: 'It was an amazing session taken and informative, and provided with experts in specialization.',
  },
  {
    name: 'Sana M Akhunji',
    university: 'Sankalchand Patel College of Eng., CE',
    feedback: 'I had a fantastic experience with InternsElite during my web development traineeship. The instructors were highly knowledgeable, patient, and approachable.',
  },
];

function WD_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p>
                  Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
                </p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6 review_component_text'>Hear What Our Students Say</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '7' : '5'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.university}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, i) => (
                          <li key={i}>
                            <FaStar color={"gold"} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.feedback}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WD_Review_Program_Page;
